// Copyright (c) 2016 Deere & Company

export const hasBusyCounter = busyCounter => busyCounter > 0;



// WEBPACK FOOTER //
// ./src/shared/services/busy-counter.js